import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.28 36.304a1 1 0 1 1 1.414 1.414 6.657 6.657 0 0 1-9.414-9.414 1 1 0 1 1 1.414 1.415 4.657 4.657 0 1 0 6.586 6.585Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7 43.807a2.7 2.7 0 0 1-3.505-3.514l3.591-8.943a5 5 0 0 1 1.105-1.673L32.636 5.97a6.729 6.729 0 0 1 9.468-.046c2.616 2.61 2.634 6.794.049 9.385L18.335 39.13a5 5 0 0 1-1.688 1.113L7.7 43.807Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.987 10.511a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm11 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z",
    fill: "currentColor"
  }));
};

var SvgEdit = styled(SvgComponent).withConfig({
  displayName: "Edit__SvgEdit",
  componentId: "sc-1txcbs7-0"
})(["", " ", ""], size, color);
export default SvgEdit;